import { useEffect, useState } from "react";
import { getFamily, getActiveProfileId, setActiveProfileId } from "@/lib/family";
import { setProfileVoice } from "@/lib/api";

export const useFamilyProfile = () => {
  const [profiles, setProfiles] = useState([]);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    getFamily().then((f) => {
      setProfiles(f.profiles);
      const p = f.profiles.find((x) => x.id === getActiveProfileId());
      setProfileVoice(p?.voice);
      if (p) setProfile(p);
    });
  }, []);

  const pickProfile = (p) => {
    setProfile(p);
    setActiveProfileId(p ? p.id : "");
    setProfileVoice(p?.voice);
  };

  return { profiles, profile, pickProfile };
};
